import axios from 'axios'
const baseUrl = process.env.REACT_APP_API_BASEURL

/**
* @function getOverallService
* @param { token }
* @description This function is used to get data
*/
export const getOverallService = async ({ token, country }) => {
    const result = axios.get(`${baseUrl}users/get/byState/submission?country=${country}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    return result;
};


/**
* @function filterOverallIndustryAndStateService
* @param { token, state, industry, toDate, fromDate}
* @description This function is used to get industry maturity data
*/
export const filterOverallIndustryAndStateService = async ({ token, country, state, industry, toDate, fromDate }) => {
    const result = axios.get(`${baseUrl}users/get/byState/submission?country=${country}&state=${state}&industry=${industry}&toDate=${toDate}&fromDate=${fromDate}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    return result;
};